import { FC } from "react";

import { classname } from "@ctra/utils";
import { ReactComponent as LogoGraphic } from "../../../assets/branding/logo.svg";
import { ReactComponent as Adisseo } from "../../../assets/branding/adisseo.svg";
import { ReactComponent as LogoWithText } from "../../../assets/branding/logo-text.svg";
import { ReactComponent as LogoWithoutText } from "../../../assets/branding/logo-without-text.svg";

export interface LogoProps extends React.HTMLAttributes<SVGElement> {
  variant?: "withText" | "noText" | "cropped" | "adisseo" | "collapsedAdisseo";
}

/**
 * Logo component
 * @param {string} variant
 * @param {string | undefined} className
 * @param {Omit<React.PropsWithChildren<LogoProps>, "variant" | "className" | "style">} rest
 * @returns {JSX.Element}
 * @constructor
 */
const Logo: FC<LogoProps> = ({ variant = "cropped", className, ...rest }) => {
  switch (variant) {
    case "withText":
      return <LogoWithText className={classname("ctra-branding-icon", className)} {...rest} />;
    case "noText":
      return <LogoWithoutText className={classname("ctra-branding-icon", className)} {...rest} />;
    case "adisseo":
      return <Adisseo className={classname("ctra-branding-icon", className)} {...rest} />;
    case "collapsedAdisseo":
      return <Adisseo className={classname("ctra-branding-icon", className)} {...rest} />;
    default:
      return <LogoGraphic className={classname("ctra-branding-icon", className)} {...rest} />;
  }
};

export default Logo;
